import { createBrowserRouter, Navigate } from 'react-router-dom';
import { AppLayout } from '../components/AppLayout';
import { LoginPage } from '../features/auth/LoginPage';
import { SelectTenantPage } from '../features/auth/SelectTenantPage';
import { ChangePasswordPage } from '../features/auth/ChangePasswordPage';
import { DashboardPage } from '../features/dashboard/DashboardPage';
import { BomDetailPage } from '../features/boms2/BomDetailPage';
import { EmailConfigPage } from '../features/settings/EmailConfigPage';
import { ContactGroupsPage } from '../features/settings/ContactGroupsPage';
import { MembersContactsPage } from '../features/members/MembersContactsPage';
import { UsersPage } from '../features/admin/UsersPage';
import { TenantsPage } from '../features/admin/TenantsPage';
import { AuditPage } from '../features/audit/AuditPage';
import {
  RequireAuth,
  RequireBusinessAccess,
  RequirePlatformAdmin,
  RequireRole,
  RedirectIfAuthed,
} from './guards';

export const router = createBrowserRouter([
  {
    path: '/login',
    element: (
      <RedirectIfAuthed>
        <LoginPage />
      </RedirectIfAuthed>
    ),
  },
  {
    path: '/select-tenant',
    element: (
      <RequireAuth>
        <SelectTenantPage />
      </RequireAuth>
    ),
  },
  {
    path: '/change-password',
    element: (
      <RequireAuth>
        <ChangePasswordPage />
      </RequireAuth>
    ),
  },
  {
    path: '/',
    element: (
      <RequireBusinessAccess>
        <AppLayout />
      </RequireBusinessAccess>
    ),
    children: [
      { index: true, element: <DashboardPage /> },
      { path: 'boms', element: <BomDetailPage /> },
      { path: 'email-config', element: <EmailConfigPage /> },
      { path: 'members', element: <MembersContactsPage /> },
      {
        path: 'audits',
        element: (
          <RequireRole roles={['admin']}>
            <AuditPage />
          </RequireRole>
        ),
      },
      { path: 'admin', element: <Navigate to="/admin/users" replace /> },
      {
        path: 'admin/users',
        element: (
          <RequirePlatformAdmin>
            <UsersPage />
          </RequirePlatformAdmin>
        ),
      },
      {
        path: 'admin/tenants',
        element: (
          <RequirePlatformAdmin>
            <TenantsPage />
          </RequirePlatformAdmin>
        ),
      },
      { path: 'contact-groups', element: <ContactGroupsPage /> },
    ],
  },
  { path: '*', element: <Navigate to="/" replace /> },
]);
